import moment from "moment";

const randomPercent = () => {
  return parseInt((Math.random() * 100).toFixed(2));
}

const nextTemp = (prev, min, max) => {
  prev = parseFloat(prev) || min + ((max - min) / 2);
  let threshold = 0.1;
  let signal = Math.random() * (max - min) + min;
  //console.log('prev: %s, signal: %s', prev, signal);
  if (prev > signal) {
    prev = prev - threshold;
  } else {
    prev = prev + threshold;
  }
  return prev.toFixed(2);
};

export const getSensorReadings = (id, type) => {
  let now = new Date();
  let start = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000); // 1 week
  let result = [];
  switch (type) {
    case "TEMPERATURE":
      let temp
      while (start < now) {
        temp = nextTemp(temp, 16, 28);
        if (randomPercent() < 80) {
          result.push({
            id,
            value: temp,
            date: moment(start).valueOf(), //.format('DD-MM-YYYY HH:mm'),
          });
        }
        start = new Date(start.getTime() + 5 * 60 * 1000);
      }
      break;

    default:
      break;
  }
  // console.log('GOT HERE: result: %o', result);
  return result;
};
